<style lang="scss" scoped>
.setting-pickup {
  color: #606266;
}
.pickup-form {
  margin-top: 20px;
}
.save-btn-container {
  text-align: right;
}
.el-icon-sort {
  transform: rotate(90deg);
}
</style>

<template>
  <div class="setting-pickup">
    <section class="container" style="position: relative;">
      <el-switch v-model="enablePickup" active-text="到店自提服务" />
      <el-form :model="store" label-width="100px" :inline="true" class="pickup-form" v-if="enablePickup">
        <el-form-item label="最早取货时间">
          <el-select v-model="store.selfbeginduration" placeholder="请选择时间">
            <el-option label="下单后5分钟" :value="300"></el-option>
            <el-option label="下单后15分钟" :value="900"></el-option>
            <el-option label="下单后30分钟" :value="1800"></el-option>
            <el-option label="下单后45分钟" :value="2700"></el-option>
            <el-option label="下单后1小时" :value="3600"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="最晚取货时间">
          <el-select v-model="store.selfendduration" placeholder="请选择时间">
            <el-option label="下单后2小时" :value="7200"></el-option>
            <el-option label="下单后2.5小时" :value="9000"></el-option>
            <el-option label="下单后3小时" :value="10800"></el-option>
            <el-option label="下单后5小时" :value="18000"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="save-btn-container" v-if="enablePickup">
        <el-button type="primary" @click="() => updateStore()">
          保存
        </el-button>
      </div>
    </section>
  </div>
</template>

<script>
/* eslint-disable */
import { rpc } from '../../../service/index';
import { M } from '../../../service/grpc';
import { getToken } from '../../../service/helper';

export default {
  name: 'setting-pickup',
  data() {
    return {
      token: getToken(),
      store: {},
      enablePickup: false
    };
  },
  watch: {
    enablePickup(v) {
      this.updateStore();
    }
  },
  created() {
    rpc('StoreAuthService.GetStore', M('Token', { token: this.token })).then(res => {
      this.store = res;
      this.enablePickup = this.store.deliverkindlistList.includes(1);
    });
  },
  methods: {
    updateStore() {
      const params = JSON.parse(JSON.stringify(this.store));
      if (this.enablePickup && !params.deliverkindlistList.includes(1)) {
        params.deliverkindlistList.push(1);
      }
      if (!this.enablePickup && params.deliverkindlistList.includes(1)) {
        params.deliverkindlistList = params.deliverkindlistList.filter(v => v !== 1);
      }
      rpc(
        'StoreStoreService.UpdateInfo',
        M('StoreWithTokenRequest', {
          token: M('Token', { token: this.token }),
          store: M('Store', {
            ...params,
            businesshoursList: params.businesshoursList.map(v => M('BusinessHours', v)),
            distancepricelistList: params.distancepricelistList.map(v => M('DistancePrice', v))
          })
        })
      ).then(res => {
        this.store = res;
      });
    }
  }
};
</script>
